import { Box, SxProps, Typography } from '@mui/material';

import { DataGrid, DataGridLayout, WorkflowMessage } from '@verantos-dev/shared-components';
import { CohortDefinitionStatus } from '@verantos-dev/types-cohorts';

import { useCohortAttritionTable } from './hooks/useCohortAttritionTable';

const workflowMessageSx: SxProps = { width: '100%', height: '348px' };
export interface CohortAttritionTableProps {
  projectId: string;
  cohortId: string;
}

export const CohortAttritionTable = ({ projectId, cohortId }: CohortAttritionTableProps) => {
  const {
    theme,
    columns,
    latestCohortStatus,
    useFetchCohortAttritionData,
    attritionHeaderMessages,
    attritionWorkflowMessages,
    attritionData,
    isInitiallyLoading,
    attritionDataError,
  } = useCohortAttritionTable({
    projectId,
    cohortId,
  });

  if (latestCohortStatus === CohortDefinitionStatus.DRAFT) {
    return (
      <WorkflowMessage
        id={'attribution-draft-state-workflowMessage'}
        title={attritionWorkflowMessages.draftTitle}
        message={attritionWorkflowMessages.draftMessage}
        sx={workflowMessageSx}
      />
    );
  }
  if (
    latestCohortStatus === CohortDefinitionStatus.PROCESSING &&
    (!attritionData?.data || attritionData?.data.length === 0)
  ) {
    return (
      <WorkflowMessage
        id="attribution-processing-state-workflowMessage"
        title={attritionWorkflowMessages.processingTitle}
        message={attritionWorkflowMessages.processingMessage}
        sx={workflowMessageSx}
      />
    );
  }
  if (!isInitiallyLoading && attritionData?.data.length === 0) {
    return (
      <WorkflowMessage
        id="attribution-no-data-state-workflowMessage"
        title={attritionWorkflowMessages.errorTitle}
        message={attritionWorkflowMessages.errorMessage}
        sx={workflowMessageSx}
      />
    );
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant="h5">{attritionHeaderMessages.stepTitle}</Typography>

      <DataGridLayout
        id="attrition-table-layout"
        data-testid="attrition-table-layout"
        sx={{
          width: '100%',
          minWidth: theme.breakpoints.values.md,
          marginTop: theme.spacing(4),
          minHeight: 250,
          maxHeight: 630,
        }}
      >
        <DataGrid
          id="attrition-table"
          data-testid="attrition-table"
          columns={columns}
          getRowId={(row) => row.id} // Updated to return the unique id of each row
          mode="client"
          disableSearchParamSync
          useFetchDataGridData={useFetchCohortAttritionData}
          columnVisibilityModel={{
            subjectsRemainingPercent: false,
            subjectsExcludedPercent: false,
          }}
          sx={{ minHeight: '250px' }}
        />
      </DataGridLayout>
    </Box>
  );
};
